<div [options]="chartOptions() ?? {}" echarts class="mini-line-chart"></div>
